Vue.component("package-shop-component", require("./Index.vue").default);
